module.exports = __webpack_public_path__ + "static/img/32012.423f5f87.jpg";